/* eslint-disable no-unused-vars */
import Moment from 'react-moment';
import es from 'moment/locale/es';
import pt from 'moment/locale/pt';
import moment from 'moment';
import { getLocale } from './utils/leads';

function initMoment() {
  moment.locale(getLocale().locale.substr(0, 2));
  Moment.globalMoment = moment;
  Moment.globalFilter = d => {
    return d.replace('.', '');
  };
}

export default initMoment;
